import api from '../api';

export async function listarCatalogoMotosPublico({ marca, categoria, q } = {}) {
  const params = {};
  if (marca) params.marca = marca;
  if (categoria) params.categoria = categoria;
  if (q) params.q = q;

  const res = await api.get('/catalogo-motos', { params });
  return res.data;
}
